<template>
    <div class="">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-copy"></i> 操作证审核 / 厂商业务员</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-tabs v-model="checkactiveorgan" @tab-click="handleClick">
                <el-tab-pane label="机械操作证书审核" name="checkfirst">
					<el-form ref="checkcerformfirst" :model="checkcerformfirst">
						<div class="apply-flex">
							<p>
								<el-form-item label="姓名"  prop='ownerName'>
									<el-input v-model="checkcerformfirst.ownerName" style="width:150px"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="审核状态"  prop='status'>
									<el-select v-model="checkcerformfirst.status" placeholder="请选择审核状态">
										<el-option label="未申请" value="1"></el-option>
										<el-option label="学习中" value="2"></el-option>
										<el-option label="考试中" value="3"></el-option>
										<el-option label="待支付" value="4"></el-option>
										<el-option label="审核中" value="5"></el-option>
										<el-option label="审核通过" value="6"></el-option>
										<el-option label="审核失败" value="7"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="checkcerformfirst.provinceId" placeholder="请选择省份" @change="provinceChange(checkcerformfirst)" style="width:150px">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="checkcerformfirst.cityId" placeholder="请选择市区" style="width:150px">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							
						</div>
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearchfirst()">查询</el-button>
						<el-button
							type="primary"
							icon="el-icon-circle-check"
							class="handle-del"
							@click="passcerApplyfirst()"
						>批量通过</el-button>
						<el-button
							type="primary"
							icon="el-icon-circle-close"
							class="handle-del"
							@click="fallbackcerApplyfirst({},'fallbackform',1)"
						>批量退回</el-button>
					</p>
					
                    <el-table
                        :data="organcerTableData"
                        border
                        class="table"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
						<template slot-scope="scope">
						{{scope.row.provinceName}}{{scope.row.cityName}}
						</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
                        <el-table-column prop="operationItems" label="操作项目"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center"></el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column prop="statusStr" label="申请状态"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
								
                                <el-button
                                    type="text"
                                    icon="el-icon-view"
                                >
								<!-- <router-link :to="'/cercheckseefjxfirst/'+scope.row.certificateApplyId" style="color: #409EFF;">
								查看 
								</router-link> -->
								
								<router-link :to="'/cercheckseefjxfirst/'+scope.row.certificateApplyId+'/'+checkactiveorgan+'/'+query.pageIndex" style="color: #409EFF;">
								查看 
								</router-link>
								
								</el-button>
                                <el-button
									v-if="scope.row.status == 5"
                                    type="text"
                                    icon="el-icon-circle-check"
                                    @click="passcerApplyfirst(scope.row)"
                                >通过</el-button>
								<el-button
									v-else
								    type="text"
								    icon="el-icon-circle-check"
									style="color: #999;"
								>通过</el-button>
								<el-button
									v-if="scope.row.status == 5"
								    type="text"
								    icon="el-icon-circle-close"
								    @click="fallbackcerApplyfirst(scope.row,'fallbackform',1)"
								>退回</el-button>
								<el-button
									v-else
								    type="text"
								    icon="el-icon-circle-close"
									style="color: #999;"
								>退回</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="query.pageIndex"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @current-change="handlePageChangefirst"
                        ></el-pagination>
                    </div>
					
					
                </el-tab-pane>
                <el-tab-pane label="机械操作证书到期换证" name="checksecond">
					<el-form ref="checkcerformsec" :model="checkcerformsec">
						<div class="apply-flex">
							<p>
								<el-form-item label="姓名"  prop='ownerName'>
									<el-input v-model="checkcerformsec.ownerName" style="width:150px"></el-input>
								</el-form-item>
							</p>
							<p>
								<el-form-item label="审核状态"  prop='status'>
									<el-select v-model="checkcerformsec.status" placeholder="请选择审核状态">
										<el-option label="未申请" value="1"></el-option>
										<el-option label="学习中" value="2"></el-option>
										<el-option label="考试中" value="3"></el-option>
										<el-option label="待支付" value="4"></el-option>
										<el-option label="审核中" value="5"></el-option>
										<el-option label="审核通过" value="6"></el-option>
										<el-option label="审核失败" value="7"></el-option>
									  </el-select>
								</el-form-item>
							</p>
							<p class="apply-flexarea">
								<el-form-item label="区域" prop="provinceId">
									<el-select v-model="checkcerformsec.provinceId" placeholder="请选择省份" @change="provinceChange(checkcerformsec)" style="width:150px">
									    <el-option
									      v-for="item in provinceOptions"
									      :key="item.provinceId"
									      :label="item.name"
									      :value="item.provinceId">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="" prop="cityId">
									<el-select v-model="checkcerformsec.cityId" placeholder="请选择市区" style="width:150px">
									    <el-option
									      v-for="item in citysOptions"
									      :key="item.cityId"
									      :label="item.name"
									      :value="item.cityId">
									    </el-option>
									  </el-select>
								</el-form-item>
							</p>
							
						</div>
					</el-form>	
					
					<p class="flex-btn">
						<el-button type="primary" icon="el-icon-search" @click="handleSearchsec()">查询</el-button>
						<el-button
							type="primary"
							icon="el-icon-circle-check"
							class="handle-del"
							@click="passcerApplysec()"
						>批量通过</el-button>
						<el-button
							type="primary"
							icon="el-icon-circle-close"
							class="handle-del"
							@click="fallbackcerApplysec({},'fallbackform',2)"
						>批量退回</el-button>
					</p>
					
					<el-table
					    :data="organcerTableData"
					    border
					    class="table"
					    ref="multipleTable"
					    header-cell-class-name="table-header"
					    @selection-change="handleSelectionChange"
					>
					    <el-table-column type="selection" width="55" align="center"></el-table-column>
					    <el-table-column prop="ownerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="provinceName,cityName" label="区域" align="center">
						<template slot-scope="scope">
						{{scope.row.provinceName}}{{scope.row.cityName}}
						</template>
						</el-table-column>
						<el-table-column prop="personName" label="业务员" align="center"></el-table-column>
					    <el-table-column prop="operationItems" label="操作姓名"></el-table-column>
						<el-table-column prop="operationCertificateNumber" label="操作证书编号" align="center"></el-table-column>
						<el-table-column prop="ownerIdentityCards" label="身份证号"></el-table-column>
						<el-table-column prop="createTimeStr" label="申请时间" align="center"></el-table-column>
						<el-table-column prop="statusStr" label="申请状态"></el-table-column>
					    <el-table-column label="操作" width="180" align="center">
					        <template slot-scope="scope">
								
					            <el-button
					                type="text"
					                icon="el-icon-view"
					            >
								<!-- <router-link :to="'/cercheckseefjxsec/'+scope.row.certificateApplyId" style="color: #409EFF;">
								查看
								</router-link> -->
								
								<router-link :to="'/cercheckseefjxsec/'+scope.row.certificateApplyId+'/'+checkactiveorgan+'/'+query.pageIndex" style="color: #409EFF;">
								查看
								</router-link>
								
								</el-button>
					            <el-button
									v-if="scope.row.status == 5"
					                type="text"
					                icon="el-icon-circle-check"
					                @click="passcerApplysec(scope.row)"
					            >通过</el-button>
								<el-button
									v-else
								    type="text"
								    icon="el-icon-circle-check"
									style="color: #999;"
								>通过</el-button>
								<el-button
									v-if="scope.row.status == 5"
								    type="text"
								    icon="el-icon-circle-close"
								     @click="fallbackcerApplysec(scope.row,'fallbackform',2)"
								>退回</el-button>
								<el-button
									v-else
								    type="text"
								    icon="el-icon-circle-close"
									style="color: #999;"
								>退回</el-button>
					        </template>
					    </el-table-column>
					</el-table>
					<div class="pagination">
					    <el-pagination
					        background
					        layout="total, prev, pager, next"
					        :current-page="query.pageIndex"
					        :page-size="query.pageSize"
					        :total="pageTotal"
					        @current-change="handlePageChangesec"
					    ></el-pagination>
					</div>
					
                </el-tab-pane>
            </el-tabs>
        </div>
		
		
		<el-dialog class="branch-dialog" title="退回原因" :visible.sync="fallbackVisible" width="600px">
		    <el-form ref="fallbackform" :model="fallbackform">
		        <el-form-item label="" prop="auditReason">
					<el-input type="textarea" v-model="fallbackform.auditReason" placeholder="请输入回退原因" class="resizeNone">
						
					</el-input>
		        </el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" v-if="btntagVisible==1" @click="savefallbackfirst()">确 定</el-button>
				<el-button type="primary" v-if="btntagVisible==2" @click="savefallbacksec()">确 定</el-button>
		        <el-button @click="fallbackVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
    </div>
</template>

<script>
	import {listProvinces,listCitysByProvinceId,listCertificateApplyExamines,listCertificateTimeexpandApplyExamines,examineCertificateApply,examineCertificateTimeexpandApply} from '../api/index';
    export default {
        name: 'certificatecheckjxshop',
        data() {
            return {
                checkactiveorgan: 'checkfirst',
				provinceOptions:[],  //省列表
				citysOptions:[],   //市列表
				checkcerformfirst:{
					ownerName:'',//车主姓名
					status:'',//审核状态
					provinceId:'',
					cityId:'',
				},  //所有的搜索表单
				checkcerformsec:{
					ownerName:'',//车主姓名
					status:'',//审核状态
					provinceId:'',
					cityId:'',
				},
				
				query: {
				    pageIndex: 1,
				    pageSize: 10
				},   //分页
				organcerTableData: [],
				multipleSelection: [],
				editVisible: false,
				pageTotal: 0,
				
				
				fallbackVisible:false,
				fallbackform:{
					auditReason:''
				},
				fallbackArr:[],
				btntagVisible:''				
               
            }
        },
		created() {
			var that =  this;
			this.checkactiveorgan = this.$route.params.checkactiveorgan
			this.query.pageIndex = this.$route.params.pageIndex
			// 省
			listProvinces({
			}).then(res => {
			    // 获取数据成功后的其他操作
				that.provinceOptions = res.data;
			});
		    this.getlistCertificateApplyExamines();  
		},
        methods: {
			// 省改变请求市
			provinceChange(Licenselyform){
				Licenselyform.cityId = '';
				listCitysByProvinceId({
					provinceId:Licenselyform.provinceId
				}).then(res => {
				    // 获取数据成功后的其他操作
					this.citysOptions = res.data;
				});
			},
			
			
			// organizationKind=3  分支
			// current: this.query.pageIndex,
			// size: this.query.pageSize
			//审核
			getlistCertificateApplyExamines() {
				this.checkcerformfirst.organizationKind = 4;
				this.checkcerformfirst.current =  this.query.pageIndex;
				this.checkcerformfirst.size = this.query.pageSize;
			    listCertificateApplyExamines(this.checkcerformfirst).then(res => {
			        // 获取数据成功后的其他操作
			    	this.organcerTableData = res.data.records;
					this.pageTotal = res.data.total;
			    });
			},
			// 到期换证
			getlistCertificateTimeexpandApplyExamines() {
				this.checkcerformsec.organizationKind = 4;
				this.checkcerformsec.current =  this.query.pageIndex;
				this.checkcerformsec.size = this.query.pageSize;
			    listCertificateTimeexpandApplyExamines(this.checkcerformsec).then(res => {
			        // 获取数据成功后的其他操作
			    	this.organcerTableData = res.data.records;
					this.pageTotal = res.data.total;
			    });
			},
			
		
			//切换
            handleClick(tab, event) {
				this.query.pageIndex = 1;
				this.checkcerformfirst = {
					ownerName:'',//车主姓名
					status:'',  //牌照编号
					provinceId:'',
					cityId:'',
				}; 
				this.checkcerformsec = {
					ownerName:'',//车主姓名
					status:'',  //牌照编号
					provinceId:'',
					cityId:'',
				};
				this.organcerTableData = [];
				if(tab.label == '机械操作证书审核'){
					this.getlistCertificateApplyExamines();
				}else if(tab.label == '机械操作证书到期换证'){
					this.getlistCertificateTimeexpandApplyExamines();
				}
				
            },
			
			// 触发搜索按钮
			handleSearchfirst() {
				this.query.pageIndex = 1;
				this.getlistCertificateApplyExamines();
			},
			handleSearchsec() {
				this.query.pageIndex = 1;
				this.getlistCertificateTimeexpandApplyExamines();
			},
			// 多选操作
			handleSelectionChange(val) {
			    this.multipleSelection = val;
			},
			//审核通过
			passcerApplyfirst(row){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var organizationcerApplyIdsArr = [];  
				if(row){
					organizationcerApplyIdsArr.push(row.certificateApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							organizationcerApplyIdsArr.push(that.multipleSelection[i].certificateApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要通过的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				console.log(organizationcerApplyIdsArr)
				
				this.$confirm('确定要通过吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineCertificateApply({
							
				        	isPass:1,                    
				        	certificateApplyIds: organizationcerApplyIdsArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							 this.query.pageIndex = 1;
				        	 this.getlistCertificateApplyExamines();
				        	 console.log(res);
							 listTaskRemindNum({}).then(ress => {
							 							 	   this.$store.state.totalNum =  ress.data.totalNum;
							 							 });
				        });
				}).catch(() => {});
				
			  },
			  
			  //换证通过
			passcerApplysec(row){
			  	var that = this;
			  	// 分支机构牌证申购申请表id集合   用于通过or回退
			  	var certificateTimeexpandApplyIdArr = [];  
			  	if(row){
			  		certificateTimeexpandApplyIdArr.push(row.certificateTimeexpandApplyId);
			  	}else{
			  		if(that.multipleSelection.length>0){
			  			for(var i in that.multipleSelection){
			  				certificateTimeexpandApplyIdArr.push(that.multipleSelection[i].certificateTimeexpandApplyId);
			  			}
			  		}else{
			  			this.$message({
			  			  message: '没有选择要通过的选项哦',
			  			  center: true
			  			});
			  			return false;
			  		}
			  	}
			  	
			  	this.$confirm('确定要通过吗？', '提示', {
			  	    type: 'warning'
			  	}).then(() => {
			  	        examineCertificateTimeexpandApply({
			  	        	isPass:1,                    
			  	        	certificateTimeexpandApplyIds: certificateTimeexpandApplyIdArr              
			  	        }).then(res => {
			  	        	// 获取数据成功后的其他操作
			  				this.$message({
			  				  message: res.message,
			  				  type: 'success'
			  				});
			  				 this.query.pageIndex = 1;
			  	        	 this.getlistCertificateTimeexpandApplyExamines();
			  	        	 console.log(res);
							 listTaskRemindNum({}).then(ress => {
							 							 	   this.$store.state.totalNum =  ress.data.totalNum;
							 							 });
			  	        });
			  	}).catch(() => {});
			  	
			    },
			  // 回退弹框
			fallbackcerApplyfirst(row,formName,btntagVisible){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var organizationcerApplyIdsArr = [];  
				if(row.certificateApplyId){
					organizationcerApplyIdsArr.push(row.certificateApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							organizationcerApplyIdsArr.push(that.multipleSelection[i].certificateApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要回退的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				this.fallbackArr = organizationcerApplyIdsArr;
				this.btntagVisible = btntagVisible;
				this.fallbackVisible = true;
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				})
				
				
			},
			fallbackcerApplysec(row,formName,btntagVisible){
				var that = this;
				// 分支机构牌证申购申请表id集合   用于通过or回退
				var certificateTimeexpandApplyIdArr = [];  
				if(row.certificateTimeexpandApplyId){
					certificateTimeexpandApplyIdArr.push(row.certificateTimeexpandApplyId);
				}else{
					if(that.multipleSelection.length>0){
						for(var i in that.multipleSelection){
							certificateTimeexpandApplyIdArr.push(that.multipleSelection[i].certificateTimeexpandApplyId);
						}
					}else{
						this.$message({
						  message: '没有选择要回退的选项哦',
						  center: true
						});
						return false;
					}
				}
				
				this.fallbackArr = certificateTimeexpandApplyIdArr;
				this.btntagVisible = btntagVisible;
				this.fallbackVisible = true;
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				})
				
				
			},
			//审核退回
			savefallbackfirst(){
				this.$confirm('确定要退回吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineCertificateApply({
							auditReason:this.fallbackform.auditReason,
				        	isPass:2,                    
				        	certificateApplyIds: this.fallbackArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.query.pageIndex = 1;
				        	this.getlistCertificateApplyExamines();
							this.fallbackVisible = false;
							listTaskRemindNum({}).then(ress => {
														 	   this.$store.state.totalNum =  ress.data.totalNum;
														 });
				        });
				}).catch(() => {});
			},
			//换证退回
			savefallbacksec(){
				this.$confirm('确定要退回吗？', '提示', {
				    type: 'warning'
				}).then(() => {
				        examineCertificateTimeexpandApply({
							auditReason:this.fallbackform.auditReason,
				        	isPass:2,                    
				        	certificateTimeexpandApplyIds: this.fallbackArr              
				        }).then(res => {
				        	// 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.query.pageIndex = 1;
				        	this.getlistCertificateTimeexpandApplyExamines();
							this.fallbackVisible = false;
							listTaskRemindNum({}).then(ress => {
														 	   this.$store.state.totalNum =  ress.data.totalNum;
														 });
				        });
				}).catch(() => {});
			},
			
			
			// 分页导航
			handlePageChangefirst(val) {
			    this.$set(this.query, 'pageIndex', val);
			    this.getlistCertificateApplyExamines();
			},
			handlePageChangesec(val) {
			    this.$set(this.query, 'pageIndex', val);
			    this.getlistCertificateTimeexpandApplyExamines();
			}
			
			
        },
        computed: {
            
        }
    }

</script>


<style scoped>
	
	.apply-flex{
		display: flex;
		display: -webkit-flex;
		flex-wrap: wrap;
	}
	.apply-flex p{
		width: 25%;
		margin-right: 20px;
	}
	
	.apply-flex p.apply-flexarea .el-form-item{
		margin-right: 10px;
	}
	.apply-flex p.apply-flexarea{
		width: 40%;
		display: flex;
		display: -webkit-flex;
	}
	.apply-flex .el-form-item{
		display: flex;
		display: -webkit-flex;
	}

	
	.flex-btn {
		margin-bottom: 20px;
		text-align: right;
		border-top: 1px solid #ddd;
		padding-top: 10px;
	}


.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>


<style>
	.apply-flex p .el-form-item__label{
		width: 80px;
	}
	.resizeNone .el-textarea__inner{
	         resize: none;  
	 }	
		
	.branch-dialog	.el-dialog__header{
		background:#409EFF;
		padding: 10px 20px;
	}
	.branch-dialog	.el-dialog__header	.el-dialog__title{
		color: #fff;
	}
</style>